import { render, staticRenderFns } from "./vHeader.vue?vue&type=template&id=1bb442af&scoped=true"
import script from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./vHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vHeader.vue?vue&type=style&index=0&id=1bb442af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb442af",
  null
  
)

export default component.exports